import { amplify } from '~/config/aws'

export const getStorageUri = (bucket: string, key: string): string => {
  return `https://s3-${amplify.Storage.AWSS3.region}.amazonaws.com/${bucket}/${key}`
}
